/** Allowed `productTitleIconStyle` values — keep in sync with backend MenuV2 schema and client Menu. */
export const PRODUCT_TITLE_ICON_STYLES = [
  "none",
  "dots",
  "flower",
  "food",
  "sparkles",
  "leaf",
  "star",
  "pizza",
  "coffee",
  "wine",
  "heart",
];
